'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.List = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _core = require('@material-ui/core');

var _FavoriteBorder = require('@material-ui/icons/FavoriteBorder');

var _FavoriteBorder2 = _interopRequireDefault(_FavoriteBorder);

var _Divider = require('../Divider');

var _Typography = require('../Typography');

var _list = require('../../schema/component/list.json');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-extraneous-dependencies */


// Lazy Load
var ImageIcon = (0, _react.lazy)(function () {
  return import('@material-ui/icons/Image');
});
var Radio = (0, _react.lazy)(function () {
  return import('../Form/Radio');
});

var defaultVariant = _list.properties.default.properties.variant;
var defaultVariantLayout = _list.properties.default.properties.variantLayout;

var useStyles = (0, _core.makeStyles)(function () {
  return {
    list: {
      padding: '0px',
      width: function width(_ref) {
        var containerWidth = _ref.containerWidth;
        return containerWidth;
      }
    },
    listItem: {
      alignItems: function alignItems(_ref2) {
        var itemAlignItems = _ref2.itemAlignItems;
        return itemAlignItems;
      },
      display: 'flex',
      height: function height(_ref3) {
        var itemHeight = _ref3.itemHeight;
        return itemHeight || 'auto';
      },
      justifyContent: function justifyContent(_ref4) {
        var itemJustifyContent = _ref4.itemJustifyContent;
        return itemJustifyContent;
      },
      padding: function padding(_ref5) {
        var itemPadding = _ref5.itemPadding;
        return itemPadding || '8px 16px';
      },
      position: 'relative'
    },
    iconPrimary: {
      color: function color(_ref6) {
        var iconPrimaryColor = _ref6.iconPrimaryColor;
        return iconPrimaryColor || 'var(--onsurface-inactive)';
      },
      margin: function margin(_ref7) {
        var iconPrimaryMargin = _ref7.iconPrimaryMargin;
        return iconPrimaryMargin || '0px';
      }
    },
    iconSecondary: {
      color: function color(_ref8) {
        var iconSecondaryColor = _ref8.iconSecondaryColor;
        return iconSecondaryColor || 'var(--onsurface-inactive)';
      },
      margin: function margin(_ref9) {
        var iconSecondaryMargin = _ref9.iconSecondaryMargin;
        return iconSecondaryMargin || '0px';
      }
    },
    image: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: function justifyContent(_ref10) {
        var imageAlign = _ref10.imageAlign;
        return imageAlign;
      },
      margin: function margin(_ref11) {
        var imageMargin = _ref11.imageMargin;
        return imageMargin || '0px';
      },
      '& .MuiAvatar-root': {
        borderRadius: function borderRadius(_ref12) {
          var imageRadius = _ref12.imageRadius;
          return imageRadius || '50%';
        },
        height: function height(_ref13) {
          var imageHeight = _ref13.imageHeight,
              imageWidth = _ref13.imageWidth;
          return imageHeight || imageWidth;
        },
        width: function width(_ref14) {
          var imageWidth = _ref14.imageWidth;
          return imageWidth || '40px';
        }
      }
    },
    title: {
      alignItems: 'center',
      display: function display(_ref15) {
        var titleDisplay = _ref15.titleDisplay;
        return titleDisplay;
      },
      justifyContent: function justifyContent(_ref16) {
        var titleAlign = _ref16.titleAlign;
        return titleAlign;
      },
      margin: function margin(_ref17) {
        var titleMargin = _ref17.titleMargin;
        return titleMargin;
      },
      '& >div': {
        color: function color(_ref18) {
          var titleColor = _ref18.titleColor;
          return titleColor;
        }
      }
    },
    divider: {
      display: 'flex',
      justifyContent: function justifyContent(_ref19) {
        var dividerAlign = _ref19.dividerAlign;
        return dividerAlign || 'flex-end';
      },
      '& > hr': {
        marginTop: '-1px',
        width: function width(_ref20) {
          var dividerWidth = _ref20.dividerWidth;
          return dividerWidth;
        }
      }
    },
    caption: {
      color: function color(_ref21) {
        var captionColor = _ref21.captionColor;
        return captionColor || 'var(--onsurface-medium-emphasis)';
      },
      margin: function margin(_ref22) {
        var captionMargin = _ref22.captionMargin;
        return captionMargin || '0px';
      },
      lineHeight: function lineHeight(_ref23) {
        var captionLineHeight = _ref23.captionLineHeight;
        return captionLineHeight;
      }
    },
    radio: {
      margin: function margin(_ref24) {
        var radioMargin = _ref24.radioMargin;
        return radioMargin;
      }
    }
  };
});

var List = function List(_ref25) {
  var avatarProps = _ref25.avatarProps,
      caption = _ref25.caption,
      captionProps = _ref25.captionProps,
      description = _ref25.description,
      descriptionProps = _ref25.descriptionProps,
      dividerProps = _ref25.dividerProps,
      IconPrimary = _ref25.IconPrimary,
      IconSecondary = _ref25.IconSecondary,
      iconPrimaryProps = _ref25.iconPrimaryProps,
      iconSecondaryProps = _ref25.iconSecondaryProps,
      image = _ref25.image,
      imageCaptionProps = _ref25.imageCaptionProps,
      listItemProps = _ref25.listItemProps,
      radioProps = _ref25.radioProps,
      subtitle = _ref25.subtitle,
      subtitleProps = _ref25.subtitleProps,
      title = _ref25.title,
      titleCaptionProps = _ref25.titleCaptionProps,
      titleProps = _ref25.titleProps,
      variant = _ref25.variant,
      variantLayout = _ref25.variantLayout,
      props = _objectWithoutProperties(_ref25, ['avatarProps', 'caption', 'captionProps', 'description', 'descriptionProps', 'dividerProps', 'IconPrimary', 'IconSecondary', 'iconPrimaryProps', 'iconSecondaryProps', 'image', 'imageCaptionProps', 'listItemProps', 'radioProps', 'subtitle', 'subtitleProps', 'title', 'titleCaptionProps', 'titleProps', 'variant', 'variantLayout']);

  var variantDefault = _list.properties[defaultVariant].properties[defaultVariantLayout].properties;
  var variantSelected = _list.properties[variant] && _list.properties[variant].properties;
  variantSelected = _list.properties[variant].properties[variantLayout] && _list.properties[variant].properties[variantLayout].properties;
  var variantValidation = variantSelected || variantDefault;
  var vv = variantValidation;

  // Flag Components
  var isIconLeft = vv.iconPrimaryPosition === 'left' || vv.iconSecondaryPosition === 'left';
  var isIconRight = vv.iconPrimaryPosition === 'right' || vv.iconSecondaryPosition === 'right';
  var isTitle = vv.isTitle !== undefined ? vv.isTitle : true;

  // Define styles variant
  var classes = useStyles({
    captionColor: variantValidation.captionColor,
    captionLineHeight: variantValidation.captionLineHeight,
    captionMargin: variantValidation.captionMargin,
    containerWidth: variantValidation.containerWidth,
    dividerAlign: variantValidation.dividerAlign,
    dividerWidth: variantValidation.dividerWidth,
    iconPrimaryColor: variantValidation.iconPrimaryColor,
    iconPrimaryMargin: variantValidation.iconPrimaryMargin,
    iconSecondaryMargin: variantValidation.iconSecondaryMargin,
    imageAlign: variantValidation.imageAlign,
    imageHeight: variantValidation.imageHeight,
    imageMargin: variantValidation.imageMargin,
    imageRadius: variantValidation.imageRadius,
    imageWidth: variantValidation.imageWidth,
    itemAlignItems: variantValidation.itemAlignItems,
    itemHeight: variantValidation.itemHeight,
    itemJustifyContent: variantValidation.itemJustifyContent,
    itemPadding: variantValidation.itemPadding,
    radioMargin: variantValidation.radioMargin,
    titleAlign: variantValidation.titleAlign,
    titleColor: variantValidation.titleColor,
    titleDisplay: variantValidation.titleDisplay,
    titleMargin: variantValidation.titleMargin
  });

  return _react2.default.createElement(
    _core.List,
    _extends({}, props, { className: classes.list, component: 'div' }),
    _react2.default.createElement(
      _core.ListItem,
      _extends({ className: classes.listItem, button: true }, listItemProps),
      variantValidation.isRadio && _react2.default.createElement(
        _react.Suspense,
        { fallback: _react2.default.createElement('div', null) },
        _react2.default.createElement(Radio, _extends({}, radioProps, { className: classes.radio }))
      ),
      variantValidation.imageShow && _react2.default.createElement(
        'div',
        { className: classes.image },
        _react2.default.createElement(
          _core.Avatar,
          _extends({}, avatarProps, { src: image, alt: 'Gambar List', title: 'Gambar List' }),
          _react2.default.createElement(
            _react.Suspense,
            { fallback: _react2.default.createElement('div', null) },
            _react2.default.createElement(ImageIcon, null)
          )
        ),
        variantValidation.imageCaptionShow && _react2.default.createElement(
          _Typography.Typography,
          _extends({}, imageCaptionProps, {
            className: classes.caption,
            variant: variantValidation.captionVariant,
            'data-display': variantValidation.captionDisplay || 'inline-block',
            'data-width': variantValidation.captionWidth || 'auto'
          }),
          caption
        )
      ),
      isIconLeft && _react2.default.createElement(
        _react.Suspense,
        { fallback: _react2.default.createElement('div', null) },
        vv.iconPrimaryPosition === 'left' && _react2.default.createElement(IconPrimary, _extends({}, iconPrimaryProps, { className: classes.iconPrimary })),
        vv.iconPrimaryPosition !== 'left' && _react2.default.createElement(IconSecondary, _extends({}, iconSecondaryProps, { className: classes.iconSecondary }))
      ),
      variantValidation.captionPosition === 'left' && _react2.default.createElement(
        _Typography.Typography,
        _extends({}, captionProps, {
          className: classes.caption,
          variant: variantValidation.captionVariant,
          'data-display': variantValidation.captionDisplay || 'inline-block',
          'data-width': variantValidation.captionWidth || 'auto'
        }),
        caption
      ),
      isTitle && _react2.default.createElement(
        'div',
        { 'data-width': '100%' },
        variantValidation.subtitlePosition === 'top' && _react2.default.createElement(
          _Typography.Typography,
          _extends({}, subtitleProps, { variant: variantValidation.subtitleVariant }),
          subtitle
        ),
        _react2.default.createElement(
          _Typography.Typography,
          _extends({}, titleProps, {
            className: classes.title,
            variant: variantValidation.titleVariant,
            'data-text-align': variantValidation.titleAlign || 'start'
          }),
          _react2.default.createElement(
            'div',
            null,
            title
          ),
          variantValidation.titleCaptionShow && _react2.default.createElement(
            _Typography.Typography,
            _extends({}, titleCaptionProps, {
              className: classes.caption,
              variant: variantValidation.titleCaptionVariant,
              'data-display': 'inline-block',
              'data-width': 'auto'
            }),
            caption
          )
        ),
        variantValidation.subtitlePosition === 'bottom' && _react2.default.createElement(
          _Typography.Typography,
          _extends({}, subtitleProps, { variant: variantValidation.subtitleVariant }),
          subtitle
        ),
        variantValidation.descriptionShow && _react2.default.createElement(_Typography.Typography, _extends({}, descriptionProps, {
          variant: variantValidation.descriptionVariant,
          dangerouslySetInnerHTML: { __html: description }
        }))
      ),
      isIconRight && _react2.default.createElement(
        _react.Suspense,
        { fallback: _react2.default.createElement('div', null) },
        vv.iconPrimaryPosition === 'right' && _react2.default.createElement(IconPrimary, _extends({}, iconPrimaryProps, { className: classes.iconPrimary })),
        vv.iconPrimaryPosition !== 'right' && _react2.default.createElement(IconSecondary, _extends({}, iconSecondaryProps, { className: classes.iconSecondary }))
      ),
      variantValidation.captionPosition === 'right' && _react2.default.createElement(
        _Typography.Typography,
        _extends({}, captionProps, {
          className: classes.caption,
          variant: variantValidation.captionVariant,
          'data-display': variantValidation.captionDisplay || 'inline-block',
          'data-width': variantValidation.captionWidth || 'auto'
        }),
        caption
      )
    ),
    _react2.default.createElement(
      'div',
      { className: classes.divider },
      _react2.default.createElement(_Divider.Divider, dividerProps)
    )
  );
};

exports.List = List;
List.defaultProps = {
  avatarProps: null,
  caption: 'Caption',
  captionProps: null,
  description: 'Lorem ipsum dolor sit amet, consectetur adipis elit, sed do eiusmod tempor.',
  descriptionProps: null,
  dividerProps: null,
  IconPrimary: _FavoriteBorder2.default,
  IconSecondary: _FavoriteBorder2.default,
  iconPrimaryProps: null,
  iconSecondaryProps: null,
  image: null,
  imageCaptionProps: null,
  listItemProps: null,
  radioProps: null,
  subtitle: 'Subtitle',
  subtitleProps: null,
  title: 'List Title',
  titleCaptionProps: null,
  titleProps: null,
  variant: 'single-line',
  variantLayout: 'layout-1'
};

List.propTypes = {
  avatarProps: _propTypes2.default.shape({}),
  caption: _propTypes2.default.string,
  captionProps: _propTypes2.default.shape({}),
  description: _propTypes2.default.string,
  descriptionProps: _propTypes2.default.shape({}),
  dividerProps: _propTypes2.default.shape({}),
  IconPrimary: _propTypes2.default.shape({}),
  IconSecondary: _propTypes2.default.shape({}),
  iconPrimaryProps: _propTypes2.default.shape({}),
  iconSecondaryProps: _propTypes2.default.shape({}),
  image: _propTypes2.default.string,
  imageCaptionProps: _propTypes2.default.shape({}),
  listItemProps: _propTypes2.default.shape({}),
  radioProps: _propTypes2.default.shape({}),
  subtitle: _propTypes2.default.string,
  subtitleProps: _propTypes2.default.shape({}),
  title: _propTypes2.default.string,
  titleCaptionProps: _propTypes2.default.shape({}),
  titleProps: _propTypes2.default.shape({}),
  variant: _propTypes2.default.string,
  variantLayout: _propTypes2.default.string
};

exports.default = List;